import styled from 'styled-components'

import Icon from '../Icon'

export const Container = styled.div`
  display: flex;
  cursor: pointer;
`

export const IconStyled = styled(Icon)`
  width: 8px;
  margin-right: 12px;
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.tiny};
  text-transform: uppercase;
`
